import { Flex, IconButton, Text, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { useContext } from 'react';

import { TopMenuContext } from '../TopMenuContext';

import './Styles/AppBar.css';

const mapStateToProps = (state) => {
    return {
        restaurantName: state.restaurantName
    }
}

const AppBar = (props) => {

    const [topMenuValues, setTopMenuValues] = useContext( TopMenuContext );

    return (
        <>
            <Flex p="4" color="white" 
                 className="frostedGlass"
                 position="fixed" top="0" zIndex="2"
                 width="100%" alignItems="center"
                 boxShadow="0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)">
                     <Text fontWeight="medium" fontSize="xl" >
                        {props.restaurantName}
                     </Text>
                     <Menu color="lightblack">
                        <MenuButton
                            as={IconButton} aria-label="Options" icon={<BiDotsVerticalRounded />}
                            variant="undecorated" isRound ml="auto" size="sm" fontSize="2xl"
                        />
                        <MenuList>
                            <MenuItem color="lightblack"
                                onClick={ ()=>{
                                    setTopMenuValues( { ...topMenuValues, stimaConto: !topMenuValues.stimaConto } )
                                } }>
                                Stima conto
                            </MenuItem>
                        </MenuList>
                    </Menu>
            </Flex>
        </>
            );
}

export default connect(mapStateToProps)(AppBar);